<template>
  <div class="wrap">
    <div class="main_con fadeInUp animated">
      <div class="breadcrumb_con">
       <el-breadcrumb separator="/">
          <i class="el-icon-location-outline left icon-location"></i>
          <span class="left">{{ $t("common.CurrentLocation") }}：</span>
          <el-breadcrumb-item><router-link to="/Home">{{ $t("common.Glang") }}</router-link></el-breadcrumb-item>
          <el-breadcrumb-item><router-link to="/Service">{{ $t("top.Service") }}</router-link></el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t("common.ServiceDetail") }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-divider></el-divider>
      <div class="detail_con" v-if="newDetailData">
        <div class="title">{{ newDetailData.title }}</div>
        <video class="video"
        v-if="newDetailData.video_src!=null && newDetailData.video_header_src!=null"
          :src="img_head_url + newDetailData.video_src"
          :poster="img_head_url + newDetailData.video_header_src"
          controls
        ></video>
        <div v-html="newDetailData.text"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {
  },
  data () {
    return {
      id: 0,
      img_head_url: '',
      lang: localStorage.lang || 'cn',
      newDetailData: ''
    }
  },
  created () {
    this.id = this.$route.query.id
    this.getNewDetailData()
  },
  methods: {
    getNewDetailData () {
      var that = this
      var json = {
        lang: that.lang,
        id: that.id
      }
      var url = '/api/get_services_detail'
      that.$lcommon.ajaxRequest('post', url, json, function (res) {
        console.log(res)
        if (res.meta.status === 200) {
          that.newDetailData = res.data.services_detail
          that.img_head_url = res.img_head_url
        }
      })
    },
    imgSrc (src) {
      var that = this
      return that.img_head_url + src
    }
  }
}
</script>
<style lang="less" scoped>
.detail_con {
  width: 1200px;
  margin: 0 auto 20px;
  position: relative;
  text-align: left;
}
.detail_con .title {
  font-size: 28px;
  color: #333;
  margin: 20px 0 30px;
  line-height: 1.6;
}
.detail_con .video{
  width: 1200px;
}
.news_icon {
  width: 60px;
  height: auto;
}
.new_more {
  color: slateblue;
}
.news_item {
  margin-top: 40px;
}
img,image{
  max-width:1200px
}
</style>
